<template>
	<div class="registered">
		<el-main style="margin-bottom: 120px;">

			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" validate="val(boolean, object))" >
			  <h3 class="title">俱乐部注册</h3>
			  
			  <el-form-item label="俱乐部名称" prop="clubName" style="display: inline-block;">
			    <el-input v-model="ruleForm.clubName" :maxlength="100" placeholder="请输入俱乐部名称"></el-input>
			  </el-form-item>
			  <el-form-item label="俱乐部简称" prop="clubShortName">
			    <el-input v-model="ruleForm.clubShortName" placeholder="请输入俱乐部简称"></el-input>
			  </el-form-item>
			  <el-form-item label="俱乐部所在城市" prop="clubCity">

			    <el-select class="w160" v-model="ruleForm.clubCity" filterable clearable placeholder="请选择城市" @change='selectCity'>
					<el-option v-for="item in cityArry" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
					</el-option>
				</el-select>
			  </el-form-item>
			  <el-form-item label="俱乐部通讯地址" prop="clubAddress">
			    <el-input v-model="ruleForm.clubAddress" placeholder="请输入俱乐部通讯地址"></el-input>
			  </el-form-item>
			  
			  <el-form-item label="证件类型" prop="clubCert">
			    <el-radio-group v-model="ruleForm.clubCert">
				    	<el-radio :label="1">社团登记证</el-radio>
	  				<el-radio :label="2">营业执照</el-radio>
			    </el-radio-group>
			  </el-form-item>
			  <el-form-item label="证件编号" prop="clubCertNumber">
			    <el-input v-model="ruleForm.clubCertNumber" :maxlength="18" placeholder="请输入证件编号"></el-input>
			  </el-form-item>
			  <el-form-item label="法人名称（发票抬头）" prop="clubCorporation">
			    <el-input v-model="ruleForm.clubCorporation" placeholder="请输入法人名称"></el-input>
			  </el-form-item>
			  
			  <el-form-item label="税号" prop="clubTax">
			    <el-input v-model="ruleForm.clubTax" placeholder="请输入税号"></el-input>
			  </el-form-item>

			  <el-form-item label="联系人姓名" prop="clubContactName">
			    <el-input v-model="ruleForm.clubContactName" placeholder="请输入联系人姓名"></el-input>
			  </el-form-item>
			  <el-form-item label="联系人电话" prop="clubContactTel" >
			    <el-input v-model.number="ruleForm.clubContactTel" :maxlength="11" placeholder="请输入联系人电话"></el-input>
			  </el-form-item>
			  <el-form-item label="联系人邮箱" prop="clubContactEmail">
			    <el-input v-model="ruleForm.clubContactEmail" placeholder="请输入联系人邮箱"></el-input>
			  </el-form-item>
			  <el-form-item label="俱乐部标识" prop="clubLabel" >
			    <el-input v-model="ruleForm.clubLabel" placeholder="请输入俱乐部标识"></el-input>
			  </el-form-item>
			  <el-form-item label="负责人姓名" prop="clubLeadName">
			    <el-input v-model="ruleForm.clubLeadName" placeholder="请输入负责人姓名"></el-input>
			  </el-form-item>

			  <el-form-item label="负责人电话" prop="clubLeadTel" >
			    <el-input v-model.number="ruleForm.clubLeadTel" :maxlength="11" placeholder="请输入负责人电话"></el-input>
			  </el-form-item>

			  <el-form-item
			    label="注册手机号"
			    prop="regMobile"
			    :rules="[
			      { required: true, message: '手机号不能为空'},
			      { type: 'number', message: '手机号必须为数字值'}
			    ]"
			  >
			    <el-input v-model.number="ruleForm.regMobile" auto-complete="off" placeholder="请输入手机号" :maxlength="11"></el-input>
			  </el-form-item>
			  <!--网址-->
			  <!--<el-form-item label="网址">
			    <el-input v-model="ruleForm.clubUrl" placeholder="请输入网址"></el-input>
			  </el-form-item>-->
			  <el-form-item label="验证码" 
			  	 prop="regCaptcha"
			  	:rules="[
			      { required: true, message: '验证码不能为空'},
			    ]"
			    style="width: 400px;">
			    <input v-model="ruleForm.regCaptcha" placeholder="验证码" id="code" :maxlength="6" style="width:95px;"></input>
          		<el-button type="primary" @click="sendCode" v-if="codeMsg=='发送验证码'" class="sendcode" style="background-color:#44C1DE;height:40px">{{codeMsg}}</el-button>
          		<el-button type="primary" v-else disabled class="sendcode" style="background-color:#44C1DE;height:40px">{{codeMsg}}</el-button>
			  </el-form-item>

			    
			  </el-form-item>
			  <!--logo-->
			   <!--<el-form-item label="LOGO">
			    <el-upload
				  class="avatar-uploader"
				  action="/marlin/sign/img/upload"
				  :show-file-list="false"
				  v-model="ruleForm.clubLogo"
				  :onError="uploadError"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="imageUrl" :src="imageUrl" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			  </el-form-item>-->
			</el-form>
			<div class="btn">
			   <el-button type="primary" @click="submitForm('ruleForm')" class="bb" round>立即注册</el-button>
			   <el-button @click="resetForm('ruleForm')" class="bc" round>已有账号</el-button>
			</div>			
			<el-dialog
			  title="恭喜您！"
			  :visible.sync="dialogVisible"
			  width="30%"
			  :before-close="handleClose">
			  <span>您已成功注册，请耐心等待系统审核，审核结果将以短信的方式通知到您的手机{{ruleForm.regMobile}}！</span>
			  <span slot="footer" class="dialog-footer">
			    <el-button type="primary" @click="toLogin">确 定</el-button>
			  </span>
			</el-dialog>
		</el-main>
		<el-footer style="text-align: center;height: 120px; font-size: 12px; color: #fff;background-color: #616b88;">
	      		<div class="backup_info" style="padding:40px 0 0px 0;">
	      			孙武击剑版权所有 | 浙ICP17020049号-1 | 
	      			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010302003025" style="display:inline-block;text-decoration:none;line-height:20px; color: #fff;" >
	      				<img src="../assets/img/backup_icon.8240878.png" style="vertical-align: middle;float:left;margin-top: 3px;">
	      				
				 		公安备案33010302003025
	      			</a>
	      		</div>
	      		<div>
	      			<p>
	      				客服电话：17682314530
	      			</p>
	      		</div>
	      </el-footer>
	</div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        ruleForm: {
        		"regCaptcha":'',
        		'regMobile':"",
         	"clubName":"",//俱乐部名称 必填
			"clubShortName":"",//俱乐部简称 必填
			"clubProvince":"330000",//俱乐部所在省编码 ，默认浙江 必填
			"clubCity":"",//俱乐部所在城市 必填
			"clubAddress":"",//俱乐部通讯地址 必填
			"clubCert":"",//证件类型 1-社团登记证 2-营业执照 必填
			"clubCertNumber":"",//证件编号 必填
			"clubCorporation":"",//法人名称（发票抬头） 必填
			//"clubUrl":null,//网址 选填
			//"clubLogo":null,//俱乐部logo 必填
			"clubContactName":"", //联系人姓名 必填
			"clubContactTel":"",//联系人电话 必填
			"clubLeadName":"",//负责人姓名  必填
			"clubLeadTel":"",//负责人 电话 必填
			"clubContactEmail":"", //联系人邮箱 选填
			"clubLabel":null,
			"clubTax":""
        },
        rules: {
          clubName: [
            { required: true, message: '请输入俱乐部名称', trigger: 'blur' },
          ],
          clubShortName:[
          	{ required: true, message: '请输入俱乐部简称', trigger: 'blur' },
          ],
          clubProvince: [
            { required: true, message: '请选择俱乐部所在省', trigger: 'change' }
          ],
          clubCity: [
            { required: true, message: '请选择俱乐部所在城市', trigger: 'change' }
          ],
          
           clubAddress: [
            { required: true, message: '请输入俱乐部通讯地址', trigger: 'blur' }
          ],
           clubCert: [
            { required: true, message: '请选择证件类型', trigger: 'change' }
          ],
           clubCertNumber: [
            { required: true, message: '请输入证件编号', trigger: 'blur' }
          ],
           clubCorporation: [
            { required: true, message: '请输入法人名称（发票抬头）', trigger: 'blur' }
          ],
           clubContactName: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' }
          ],
           clubContactTel: [
            { required: true, message: '请输入联系人电话', trigger: 'blur' },
            { type: 'number', message: '电话必须为数字值'}
          ],
          clubLeadName: [
            { required: true, message: '请输入负责人姓名', trigger: 'blur' }
          ],
          clubLeadTel: [
            { required: true, message: '请输入负责人电话', trigger: 'blur' },
            { type: 'number', message: '电话必须为数字值'}
          ],
          clubContactEmail:[
          	{ required: true, message: '请输入联系人邮箱', trigger: 'blur' },
          ],
          clubUrl:[
          	{ required: true, message: '请输入网址', trigger: 'blur' },
          ],
          clubTax:[
            { required: true, message: '请输入税号', trigger: 'blur' },
          ]
        },
        
        codeMsg:"发送验证码",
        imageUrl: '',
        
       addForm:{
				mobile:'',
				type:'reg',
		},
        	provinceArry: [],
		cityArry: [],
		countyArry: [],
		allCityArry: [],
		allCountyArry: [],
		
		dialogVisible:false
      };
    },
    mounted() {
			var self = this
			this.selectCity()
    },	
    methods: {
    		//选择省
    		selectCity() {
			var self = this
				axios.get('/marlin/sign/param/area/query/city/'+this.ruleForm.clubProvince)
				.then(response => {
					var rst = response.data.rst
					if(response.data.code == 0 && rst.length > 0) {
						self.cityArry = rst
					} else {
						self.cityArry = []
						self.ruleForm.clubCity = ''
					}
				}, response => {
					// error callback
				})
		},
		//发送验证码
    		sendCode(){
				var that=this
				let postData={
					"mobile":this.ruleForm.regMobile,
					"type":"reg"
				}
				axios.post('/marlin/sign/sms/send',postData)
				.then(function(res){
					if(res.data.code==0){
						var num=60;
						var set=	setInterval(function(){ 
								if(num>1){
								num--
								that.codeMsg=num+'s后重新发送'
								}else{
									
									clearInterval(set)
									that.codeMsg="发送验证码"
									return num=60;
								}
							}, 1000);
							that.$alert('验证码发送成功！请注意查收', '提示', {
					          confirmButtonText: '确定',
					          callback: action => {
					          	
					          }
					        });
					}else{
						that.$alert(res.data.msg, '提示', {
				          confirmButtonText: '确定',
				          callback: action => {
				          	
				          }
				        });
					}
					
				})
				.catch(function(res){
					
				})
	    },
      submitForm(formName) {
		var self=this;
        this.$refs[formName].validate((valid,callback) => {
          if (valid) {
	            var postData=self.ruleForm
	            axios.post('/marlin/sign/club/info/apply',postData)
	            .then(function(res){
	            		if(res.data.code==0){
	            			self.dialogVisible=true
	            		}else{
	            			
				        self.$confirm(res.data.msg, {
				          confirmButtonText: '确定',
				          type: 'error'
				        }).then(() => {
						
				        }).catch(() => {
				        	
				        });
	            		}
	            })
	            .catch(function(res){
	            		overdue(res.response,res.response.status,self)
	            })
          } else {
	            this.$confirm('您填写的信息有误,请确认信息后提交！', '错误', {
		          confirmButtonText: '确定',
		          showCancelButton:false,
		          type: 'error'
		        }).then(() => {

		        }).catch(() => {
		        		
		        });
	            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
              	this.$router.push('/')
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.ruleForm.clubLogo=res.rst[0].url
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      toLogin(){
      	this.dialogVisible=false;
      	this.$router.push('/')
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.$router.push('/')
          })
          .catch(_ => {});
      },
       uploadError (response, file, fileList) {
    	  },
    	  val(Boolean,obj){
    	  }
    }
  }
</script>
<style lang="less">
	.registered{

		.el-form{
			margin: auto;
			width: 800px;
		}
		.el-form-item__label{
			width: 165px !important;
		}
		.el-form-item__content{
			margin-left: 165px !important;
		}
		.btn{
			text-align: center;
			margin-top: 20px;
		}
		.title{
		text-align: center;
		}	
		.el-form-item{
			display:inline-block;
			width: 370px;
		}
	}
	#code{
		width:175px;
		-webkit-appearance: none;
	    background-color: #fff;
	    background-image: none;
	    border-radius: 4px;
	    border: 1px solid #dcdfe6;
	    -webkit-box-sizing: border-box;
	    box-sizing: border-box;
	    display: inline-block;
	    font-size: inherit;
	    height: 40px;
	    line-height: 40px;
	    outline: 0;
	    padding: 0 15px;
	}
	input::-webkit-input-placeholder{
            color:#c4c8cf;
        }
        input::-moz-placeholder{   /* Mozilla Firefox 19+ */
            color:#c4c8cf;
        }
        input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
            color:#c4c8cf;
        }
        input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
            color:#c4c8cf;
        }
	#code:focus{
		border-color: #409EFF;
	}
	.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/registered.vue